import { FunctionComponent, useMemo } from "react";
import {
  selectPlanItemsEditing,
  selectPlanView,
} from "@store/plan/planReducer";
import { useAppSelector } from "@store/store";
import { getLocation } from "@lib/maps/directions";
import { PlanMarker } from "../elements/PlanMarker";
import { PlanItem } from "@dto/PlanItem";
import { useMatch } from "react-router";
/**
 * Show map pins when the user is editing their plan.
 */
const PlanEditRoute: FunctionComponent = () => {
  const planItems = useAppSelector(selectPlanItemsEditing);
  const planView = useAppSelector(selectPlanView);
  const isPlanScreen = useMatch("/plan");

  const uniqueLocations = useMemo(() => {
    // Filter out duplicate locations
    return planItems.filter((item, index, array) => {
      if (item.type !== "planItem") {
        return false;
      }

      const location = getLocation(item.item as PlanItem);
      return (
        index ===
        array.findIndex((otherItem) => {
          if (otherItem.type !== "planItem") {
            return false;
          }

          const otherLocation = getLocation(otherItem.item as PlanItem);
          return (
            location.latitude === otherLocation.latitude &&
            location.longitude === otherLocation.longitude
          );
        })
      );
    });
  }, [planItems]);

  if (planView !== "edit" || !isPlanScreen) {
    return null;
  }

  return (
    <>
      {uniqueLocations.map((item, index) => {
        const location = getLocation(item.item as PlanItem);
        return (
          <PlanMarker
            key={`${location.latitude}-${location.longitude}`}
            coordinates={location}
            ordinal={index + 1}
          />
        );
      })}
    </>
  );
};

export { PlanEditRoute };
